/* eslint-disable no-restricted-syntax */
import { mapActions, mapState } from 'vuex';
import loaderMixin from '@/mixins/loader';
import disqusMixin from '@/mixins/disqus';
import cmsContentMixin from '@/mixins/cmsContent';
import scrollTo from '@/utils/scrollTo';

export default {
  mixins: [
    cmsContentMixin,
    disqusMixin,
    loaderMixin,
  ],
  props: {
    storyId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      storyContent: '',
    };
  },
  metaInfo() {
    if (this.currentStoryDetail !== null) {
      return {
        title: this.currentStoryDetail.seoTitle,
      };
    }
    return {};
  },
  computed: {
    ...mapState('browse', ['currentStoryDetail']),
  },
  methods: {
    ...mapActions('browse', ['getStoryDetail', 'clearCurrentStoryDetail']),
  },
  mounted() {
    this.loaderAdd(document.body);
    this.getStoryDetail({ index: this.storyId })
      .then(() => {
        this.storyContent = `${this.currentStoryDetail.bodyCSS || ''}${this.currentStoryDetail.bodyHTML || ''}`;
        this.loaderRemove(document.body);
        this.installDynamicControls({
          data: {
            ...this.currentStoryDetail,
          },
        });

        if (!window.location.hash) return

        this.$nextTick(() => {
          const elementId = window.location.hash.replace("#", "")
          const element = window.document.getElementById(elementId)
          if (element !== null) {
            scrollTo(element)
          }
        })
      })
      .catch(() => this.loaderRemove(document.body));
  },
  beforeDestroy() {
    this.clearCurrentStoryDetail();
  },
};



// WEBPACK FOOTER //
// ./src/components/pages/page-story-detail/page-story-detail.js